/* eslint-disable jsx-a11y/scope */
/* eslint-disable no-dupe-keys */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import Content from "../../../../layout/content/Content";
import { Card, Spinner, FormGroup } from "reactstrap";
import { Button, Block, Row, Col, Icon, } from "../../../../components/Component";
import Swal from "sweetalert2";
import Head from "../../../../layout/head/Head";
import { DownloadTableExcel } from 'react-export-table-to-excel';
import OptionCDisable from "../../../components/DynmicOption/OptionCDisable.";
import ER1Update from "./ER1Update";

const ER1Data = ({ ...props }) => {
    const [dataactive, setdataactive] = useState([]);
    const [Gloading, setGloading] = useState(false);
    const [userData, setuserData] = useState("");
    const [employmentId, setemloymentId] = useState(0);
    const [Draft, setDraft] = useState(true);
    const [loading, setloading] = useState(false);
    const month1 = ["Test", "JANUARY", "FEBRUARY", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUGUST", "SEPTEMBER", "OCTOBER", "NOVEMBER", "DECEMBER"]
    const today = new Date();
    const tableRef = useRef(null);
    const [formData, setFormData] = useState({
        EmploymentId: Number(props.employmentId),
        UserId: Number(localStorage.getItem("userId")),
        ParametersId: Number(props.parametersId),
        month: sessionStorage.getItem("CurrentMonth") === null ? (today.getMonth() === 0 ? 12 : today.getMonth()) : sessionStorage.getItem("CurrentMonth"),
        dummymonth: sessionStorage.getItem("CurrentMonth") === null ? month1[today.getMonth()] : month1[sessionStorage.getItem("CurrentMonth")],
        year: sessionStorage.getItem("CurrentYear") === null ? (today.getMonth() === 0 ? today.getFullYear() - 1 : today.getFullYear()) : sessionStorage.getItem("CurrentYear"),
        EmploymentRefId: 15,
    });
    const onInputChange = (month, year) => {
        setFormData({ ...formData, month: month, year: year });

    };

    const getdata2 = async (emp) => {

        const sendData = {

            EmploymentId: Number(emp)
        }

        //console.log(sendData)
        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/GetEr1param', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    setdataactive(data)
                })


    };
    const getdata = async () => {

        const sendData = {
            EmploymentRefIdEr: Number(formData.EmploymentRefId),
            UserId: Number(localStorage.getItem("userId")),
        }
        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/Checkdraft', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    //console.log(data)
                    if (data === "NO") {
                        setloading(false)
                        setDraft(true)

                    }
                    else {
                        setloading(false)
                        setDraft(false)
                        getdata2(data.employmentIdEr)
                        setemloymentId(data.employmentIdEr)
                        setuserData(data)
                    }

                })


    };
    const generate = async () => {
        setloading(false)
        setGloading(true)
        const sendData = {
            UserId: Number(localStorage.getItem("userId")),
            EmploymentRefIdEr: Number(formData.EmploymentRefId),
            YearId: Number(formData.year),
            MonthId: Number(formData.month),
        }
        /* //console.log(sendData)*/

        await fetch(process.env.REACT_APP_API_LINK + 'api/ER/GenerateER1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === "Error") {
                        Swal.fire({
                            title: ' This Month Report is Already Submitted',
                            icon: 'error',

                        })
                    } else {
                        setloading(false)
                        setGloading(false)
                        getdata()
                    }

                })
    };
    
    useEffect(() => {

        setloading(true)
        getdata()

    }, [])

    const onFormSubmit = async () => {

        Swal.fire({
            title: 'Are You Sure you want to Submit  ?',
            icon: 'question',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Yes',
            confirmButtonColor: 'success',
            denyButtonText: `No`,
        }).then(async (result) => {

            if (result.isConfirmed) {
                const sendData = {

                    EmploymentIdEr: employmentId,
                }

                /* //console.log(sendData)*/
                await fetch(process.env.REACT_APP_API_LINK + 'api/ER/Submitform', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(sendData)

                })
                    .then(response => response.json())
                    .then(
                        data => {
                            if (data === "Done") {
                                props.history.push("/ERDashboard")
                            } else {
                                Swal.fire({
                                    title: 'Data Not Submitted',
                                    icon: 'error',

                                })
                            }

                        })


            } else if (result.isDenied) {
                getdata()
            }
        })
    };
    const ADDDynamic = async () => {
        setloading(false)
        const sendData = {
            EmploymentId: employmentId,
            EmploymentRefIdEr: Number(formData.EmploymentRefId),

        }
        //console.log(sendData)

        await fetch(process.env.REACT_APP_API_LINK + 'api/Er/DynamicAddEr1', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(sendData)

        })
            .then(response => response.json())
            .then(
                data => {
                    if (data === 'Done') {
                        setloading(true)
                        getdata()
                    } else {
                        window.location.reload()
                    }

                })


    };

    const onSaveDraft = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',
        })
        getdata()
    };
    const onSaveDraftGoBack = async () => {

        Swal.fire({
            title: 'Data Saved Successfully',
            icon: 'success',

        })
        props.history.push("/Dashboard")
        getdata()

    };

    return (
        <React.Fragment>
            <Head title="AllUser" />
            <Content>
                {loading ? <Spinner color="success" /> :
                    <Block>
                        <Button onClick={() => window.location.href = '/ERDashboard'} color="dark"><em class="icon ni ni-back-alt"></em> BACK</Button>
                        <Card className="card-bordered card-stretch" style={{ padding: 20 }}>
                            {/*<NavbarDynamic />*/}
                            <h3 style={{ marginBottom: 40 }}>ER-I   <DownloadTableExcel
                                filename="ES1 Edit Report"
                                sheet="users"
                                currentTableRef={tableRef.current}
                            >
                                {Draft ? null : <Button style={{ float: "right" }} color="warning" ><Icon class="icon ni ni-download"></Icon><b style={{ fontSize: 18 }}>Export Excel</b></Button>}
                            </DownloadTableExcel>   </h3>

                            {Draft ? <Row className="gy-4">

                                <Col md="6">
                                    <OptionCDisable onInputChange={onInputChange} namemain="year" mainid="year" />
                                </Col>
                                {Gloading === false ? <Col md="6">
                                    <Button color="success" onClick={() => generate()} >Generate</Button>
                                </Col> : <Spinner color="success" />}
                            </Row> :
                                <Card style={{ marginTop: 20, border: "2px solid black", padding: 10 }} className="card-bordered card-stretch">
                                    <Row className="gy-4">
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Name of State: <label style={{ fontWeight: "normal" }}>{userData.user !== undefined ? userData.user.state : "Not Specified"}  </label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    EMI 1.0 Public Sector Total <label style={{ fontWeight: "normal" }}> </label>
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        <Col md="6">
                                            <FormGroup>
                                                <label className="form-label" htmlFor="Month">
                                                    Statement showing the employment in total Public sector Establishments for the Quarter ending…. 
                                                </label>

                                            </FormGroup>
                                        </Col>
                                        
                                    </Row>
                                    <div className="card-inner-group" style={{ border: '2px solid black', padding: 2 }}>

                                        <div style={{ height: window.innerHeight - 300, width: 'auto', overflow: 'scroll' }} className="table-responsive">
                                            <table className="table" style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                    <tr >

                                                        <th rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                           N.I.C 2008 at 5 digit level

                                                        </th>
                                                        <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Number of Establishment

                                                        </th>
                                                        <th colSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Employment Position in the Establishments

                                                        </th>
                                                        <th rowSpan="2" colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Changes in Employment

                                                        </th>

                                                        <th rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Estimated Employment in Defaulting Establishment

                                                        </th>
                                                        <th rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >

                                                            Remarks
                                                        </th>
                                                      


                                                    </tr>
                                                    <tr >


                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Addressed

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Responded

                                                        </th>
                                                        <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Previous  Quarter

                                                        </th>
                                                        <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Current Quarter

                                                        </th>
                                                    </tr>
                                                    <tr >


                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Total

                                                        </th>
                                                        <th  style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Women

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Total

                                                        </th>
                                                        <th  style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Women

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Total

                                                        </th>
                                                        <th  style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Women

                                                        </th>
                                                       
                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    {dataactive !== [] ? dataactive.map((details) =>

                                                        
                                                        <ER1Update edit={true} er1detailsId={details.er1detailsId} sno={details.sno} name={details.name} parametersId={details.parametersId} employmentId={employmentId} ER1Update={ER1Update} />

                                                    ) : null}
                                                    <tr>
                                                        <Button color="success" onClick={() => ADDDynamic()}>ADD</Button>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>


                                        <div style={{ visibility: 'hidden', height: 0, width: 0 }} className="table-responsive">
                                            <table className="table" ref={tableRef} style={{ borderCollapse: "separate", borderSpacing: 0 }}>
                                                <thead style={{ position: '-webkit-sticky', position: "sticky", top: 0, backgroundColor: '#edecec' }}>
                                                    <tr >

                                                        <th rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            N.I.C 2008 at 5 digit level

                                                        </th>
                                                        <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Number of Establishment

                                                        </th>
                                                        <th colSpan="4" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Employment Position in the Establishments

                                                        </th>
                                                        <th rowSpan="2" colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Changes in Employment

                                                        </th>

                                                        <th rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Estimated Employment in Defaulting Establishment

                                                        </th>
                                                        <th rowSpan="3" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >

                                                            Remarks
                                                        </th>



                                                    </tr>
                                                    <tr >


                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Addressed

                                                        </th>
                                                        <th rowSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Responded

                                                        </th>
                                                        <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Previous  Quarter

                                                        </th>
                                                        <th colSpan="2" style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Current Quarter

                                                        </th>
                                                    </tr>
                                                    <tr >


                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Total

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Women

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Total

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Women

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Total

                                                        </th>
                                                        <th style={{ textAlign: 'center', border: '1px solid black', padding: 10, verticalAlign: 'inherit' }} >
                                                            Women

                                                        </th>

                                                    </tr>
                                                </thead>

                                                <tbody>

                                                    {dataactive !== [] ? dataactive.map((details) =>

                                                        details.parentId <= 0 ?
                                                            <tr scope="row" >
                                                            </tr> :
                                                            <ER1Update edit={true} er1detailsId={details.er1detailsId} sno={details.sno} name={details.name} parametersId={details.parametersId} employmentId={employmentId} ER1Update={ER1Update} />

                                                    ) : null}



                                                </tbody>
                                            </table>

                                        </div>



                                    </div>
                                    <div style={{ marginTop: 30, marginRight: -10 }}>
                                        <Button color='info' onClick={() => onSaveDraft()}>Save As Draft<em class="icon ni ni-unarchive"></em></Button>  <Button onClick={onFormSubmit} color='success'>Submit <em class="icon ni ni-file-check"></em></Button> <Button color='warning' onClick={() => onSaveDraftGoBack()}>Save As Draft And Back To Dashboard<em class="icon ni ni-signout"></em></Button>
                                    </div>
                                </Card>}



                        </Card>

                    </Block>}

            </Content>

        </React.Fragment>
    );
};

export default ER1Data;
